import React from "react";
import { Button, Popconfirm, Tooltip, Popover } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined, WarningOutlined, PlusOutlined, MoreOutlined, ClusterOutlined, StopOutlined, ClockCircleOutlined, CloudServerOutlined, CloudSyncOutlined } from "@ant-design/icons";
import "./layouts-styles.css"
const classes = "da-px-10 da-my-0";

const BaseAction = (props) => {

  const Actions = () => {
    return <>
      <div style={ { display: 'flex', flexDirection: 'row' } }>

        { props.onCancelRequest ? <Tooltip title="Cancel Request"><Button className={ classes } type="link" size="middle" onClick={ () => cancelRequest(props) }><StopOutlined className="icon-style da-text-color-info-1" /></Button></Tooltip> : null }

        { props.onViewFlow ? <Tooltip title={ 'Flow' }><Button className={ classes } type="link" size="middle" onClick={ () => viewFlow(props) }><ClusterOutlined className="icon-style da-text-color-info-1" /></Button></Tooltip> : null }

        { props.onViewHistory ? <Tooltip title={ 'History' }><Button className={ classes } type="link" size="middle" onClick={ () => viewHistory(props) } ><ClockCircleOutlined className="icon-style da-text-color-info-1" /></Button></Tooltip> : null }

        { props.onView ? <Tooltip title={ 'View' }> <Button className={ classes } type="link" size="middle" onClick={ () => view(props) } ><EyeOutlined className="icon-style da-text-color-info-1" /></Button></Tooltip> : null }

        { props.onAdd ? <Tooltip title="Add New"> <Button className={ classes } type="link" size="middle" onClick={ () => add(props) }><PlusOutlined className="icon-style" /></Button></Tooltip> : null }

        { props.onEdit ? <Tooltip title={ 'Edit' }> <Button className={ classes } type="link" size="middle" onClick={ () => edit(props) }><EditOutlined className="icon-style da-text-color-warning-1" /></Button></Tooltip> : null }

        { props.onDelete ? (
          <Popconfirm title="Are you sure?" icon={ <WarningOutlined /> } onConfirm={ () => del(props) }>
            <Tooltip title={ 'Delete' }>
              <Button className={ classes } type="link" size="middle"><DeleteOutlined className="icon-style  da-text-color-danger-1" /></Button>
            </Tooltip>
          </Popconfirm>
        ) : null }

        { props.onSeed ? (
          <Popconfirm title={ <span>Are you sure, you want to seed <br />all tenants on this server?</span> } icon={ <WarningOutlined /> } onConfirm={ () => seed(props) }>
            <Tooltip title={ 'Seed Tenants' }>
              {
                <Button className={ classes } type="link" size="middle"><CloudSyncOutlined className="icon-style  da-text-color-danger-1" /></Button>
              }
            </Tooltip>
          </Popconfirm>
        ) : null }
        { props.children }
      </div>
    </>
  }
  return (
    <>
      <Actions />
    </>
  );
};

const cancelRequest = (props) => {
  if (props.onViewFlow) {
    props.onCancelRequest(props.each);
  }
}
const viewFlow = (props) => {
  if (props.onViewFlow) {
    props.onViewFlow(props.each);
  }
}
const viewHistory = (props) => {
  if (props.onView) {
    props.onViewHistory(props.each);
  }
}
const view = (props) => {
  if (props.onView) {
    props.onView(props.each);
  }
}

const edit = (props) => {
  if (props.onEdit) {
    props.onEdit(props.each);
  }
}

const add = (props) => {
  if (props.onAdd) {
    props.onAdd(props.each);
  }
}

const del = (props) => {
  if (props.onDelete) {
    props.onDelete(props.each);
  }
}

const seed = (props) => {
  if (props.onSeed) {
    props.onSeed(props.each);
  }
}

export default BaseAction;